<template>
  <pt-save-sign-detail class="pt-save-sign-detail__page" :id="id" :signId="signId"></pt-save-sign-detail>
</template>

<script>
import PtSaveSignDetail from 'cps/appointment-application/pt-save-sign/pt-save-sign-detail/withData'
export default {
  name: 'pt-save-sign-detail__view',
  components: {
    'pt-save-sign-detail': PtSaveSignDetail
  },
  props: {
    id: {
      type: String,
      default: null
    },

    signId: {
      type: String
    }
  }
}
</script>
